function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Circle, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Circle, {
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#5B41F0",
  strokeWidth: 2,
  d: "M23.854 17.754h-13",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgIconFocusLess(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35
  }, props), _ref);
}

export default SvgIconFocusLess;